module.exports = __webpack_public_path__ + "static/media/testing_centre_icon.53672a0b.svg";